import React, { useEffect, useState } from "react";
import SongCommentInput from "./SongCommentInput";
import SongCommentItem from "./SongCommentItem";
import {
  getSongComments,
  addSongComment,
} from "../../user/services/songService";

const LIMIT = 20;

const SongComments = ({ songId }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [start, setStart] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  /* ================= FETCH COMMENTS ================= */

  const fetchComments = async (page = 1, append = false) => {
    try {
      setFetching(true);

      const res = await getSongComments(songId, page, LIMIT);

      if (res?.status) {
        const newComments = res.comments || [];

        if (append) {
          setComments((prev) => [...prev, ...newComments]);
        } else {
          setComments(newComments);
        }

        setHasMore(newComments.length === LIMIT);
        setStart(page);
      }
    } catch (error) {
      console.error("Fetch comments error:", error);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    if (songId) {
      fetchComments(1);
    }
  }, [songId]);

  /* ================= ADD COMMENT ================= */

  const handleAddComment = async (text) => {
    try {
      setLoading(true);

      const res = await addSongComment(songId, text);

      if (res?.status && res.comment) {
        // add instantly on top (better UX)
        setComments((prev) => [res.comment, ...prev]);
      }
    } catch (error) {
      console.error("Add comment error:", error);
      alert("Login required to comment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <h4>Comments</h4>

      {/* Input */}
      <SongCommentInput
        onSubmit={handleAddComment}
        loading={loading}
      />

      {/* Loading */}
      {fetching && <p>Loading comments...</p>}

      {!fetching && comments.length === 0 && (
        <p style={{ color: "#777" }}>No comments yet</p>
      )}

      {/* Comments List */}
      {comments.map((comment) => (
        <SongCommentItem
          key={comment._id || comment.createdAt}
          comment={comment}
        />
      ))}

      {/* Load More */}
      {hasMore && !fetching && (
        <button
          onClick={() => fetchComments(start + 1, true)}
          style={{
            marginTop: "10px",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            background: "#ff4d67",
            color: "#fff",
            cursor: "pointer"
          }}
        >
          Load More
        </button>
      )}
    </div>
  );
};

export default SongComments;